const root = "/cloud-subscriptions";

export const cloudSubscriptionIdRouteParam = "cloudSubscriptionId";

export const cloudSubscriptionRoutes = {
  root: root,
  detail: (id: string) => ({
    root: `${root}/${id}`,
  }),
  loadBySerial: (serialId: string) => ({
    root: `${root}/serial/${serialId}`,
  }),
};
